/**
 * Stable CSS class names for E2E — Customer basket infos V2.
 */
export const CB2 = {
    page: 'customer-basket-infos-v2-page',
    basketsColumn: 'customer-basket-infos-v2-page__baskets-column',
    basketsPaper: 'customer-basket-infos-v2-page__baskets-paper',
    basketTable: 'customer-basket-infos-v2-page__basket-table',
    summaryColumn: 'customer-basket-infos-v2-page__summary-column',
    summaryCard: 'customer-basket-infos-v2-page__summary-card',

    inputAvatarProduct: 'customer-basket-infos-v2-input--avatar-product-thumb',

    fieldSummaryTitle: 'customer-basket-infos-v2-field--summary-title',
    fieldTotalProductPrice: 'customer-basket-infos-v2-field--total-product-price',
    fieldDiscounts: 'customer-basket-infos-v2-field--discounts',
    fieldSubtotal: 'customer-basket-infos-v2-field--subtotal',
    fieldCargo: 'customer-basket-infos-v2-field--cargo',
    fieldGrandTotal: 'customer-basket-infos-v2-field--grand-total',
} as const;

export const cb2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
